import { AppConfig } from "../../../Config/app-config";
import http from "../../../NetworkServices/http";

let consoleBaseUrl = process.env.REACT_APP_CH_CONSOLE_API_BASE_URL;
consoleBaseUrl = consoleBaseUrl + "api/v1";

export class CatalogService {
  // post whatsapp config
  // static facebookConfigData(data: any) {
  //   return http.post(
  //     `${consoleBaseUrl}${Endpoints.ADD_FACEBOOK_CONFIG_URL}`,
  //     data,
  //   );
  // }

  static CatalogConfigData(data: any) {
    return http.post(
      `${consoleBaseUrl}${Endpoints.CATALOG_CONFIG_URL}`,
      data,
    );
  }

  static async getCatalogConfig() {
    try {
      const response = await fetch(`${process.env.REACT_APP_WHASTAPP_DOAMIN}api/v1/whatsapp/catalog/get_config`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "geta-host": AppConfig.getLoggedInData()?.data?.geta_host,
        }
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching default flow and categories:', error);
      throw error;
    }
  }


  static async getCatalogList() {
    try {
      const response = await fetch(`${process.env.REACT_APP_WHASTAPP_DOAMIN}api/v1/whatsapp/catalog/get_catalog_list`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "geta-host": AppConfig.getLoggedInData()?.data?.geta_host,
        }
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching default flow and categories:', error);
      throw error;
    }
  }

  static async setCatalogId(payload:any) {
    try {
      const response = await fetch(`${process.env.REACT_APP_WHASTAPP_DOAMIN}api/v1/whatsapp/catalog/set_catalog`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "geta-host": AppConfig.getLoggedInData()?.data?.geta_host,
        },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching default flow and categories:', error);
      throw error;
    }
  }

  static async getCatalogProductList(payload:any) {
    try {
      const response = await fetch(`${process.env.REACT_APP_WHASTAPP_DOAMIN}api/v1/whatsapp/catalog/product_list?limit=${payload?.limit}&offset=${payload?.offset}&search=${payload?.search ? payload?.search : ""}&selectedIds=${payload?.seletedIds ? payload?.seletedIds : "" }`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "geta-host": AppConfig.getLoggedInData()?.data?.geta_host,
        }
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching default flow and categories:', error);
      throw error;
    }
  }

  static async getCatalogProductCollection(payload:any) {
    try {
      const response = await fetch(`${process.env.REACT_APP_WHASTAPP_DOAMIN}api/v1/whatsapp/catalog/product_collection?limit=${payload?.limit}&offset=${payload?.offset}&search=${payload?.search ? payload?.search : ""}`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "geta-host": AppConfig.getLoggedInData()?.data?.geta_host,
        }
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching default flow and categories:', error);
      throw error;
    }
  }

  static async syncCatalogProductCollection(payload:any) {
    try {
      const response = await fetch(`${process.env.REACT_APP_WHASTAPP_DOAMIN}api/v1/whatsapp/catalog/sync`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "geta-host": AppConfig.getLoggedInData()?.data?.geta_host,
        }
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching default flow and categories:', error);
      throw error;
    }
  }
  // // get whatsapp config data list
  // static getFacebookConfigData() {
  //   return http.get(`${consoleBaseUrl}${Endpoints.FACEBOOK_CONFIG_DATA_URL}`);
  // }

  // // get whatsapp config data list
  static shopifyProductSync(data: any) {
    return http.post(`${consoleBaseUrl}${Endpoints.SHOPIFY_PRODUCT_SYNC}`, data);
  }

  static getShopifyProductSync(data: any) {
    return http.get(`${consoleBaseUrl}${Endpoints.SHOPIFY_PRODUCT_SYNC}`);
  }

  // static disconnectSingleFbPage(data: any) {
  //   return http.post(
  //     `${consoleBaseUrl}${Endpoints.FACEBOOK_DISCONNECT_PAGE_URL}`,
  //     data,
  //   );
  // }
}

// Label EndpointValidate whatsapp Settings
class Endpoints {
  // static ADD_FACEBOOK_CONFIG_URL = "/workspace/facebook-integrations";
  // static FACEBOOK_CONFIG_DATA_URL = "/workspace/get-facebook-configuration";
  // static FACEBOOK_LOGOUT_URL = "/workspace/facebook-logout";
  // static FACEBOOK_DISCONNECT_PAGE_URL =
  //   "/workspace/delete-facebook-subscribe-page";
  static CATALOG_CONFIG_URL = "/workspace/meta/catalogue/auth/callback";
  static SHOPIFY_PRODUCT_SYNC = "/workspace/meta/catalogue/data/sync";

}
